export function joinUrl(baseUrl: string, path: string) {
  const normalizedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

export function getApiUrls(baseUrl: string, spaceId: string) {
  const encodedSpaceId = encodeURIComponent(spaceId);

  return {
    CONTACTS: joinUrl(baseUrl, `/contacts/${encodedSpaceId}`),
    MEDIA: joinUrl(baseUrl, `/media/${encodedSpaceId}`),
    SETTINGS: joinUrl(baseUrl, `/settings/${encodedSpaceId}`),
    CALENDAR: joinUrl(baseUrl, `/calendar/${encodedSpaceId}`),
  };
}
